import moment from "moment";

const parseNotificationDate = (value) => {
  if (!value) return null;
  const date = moment.parseZone(value, [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY"], true);
  return date.isValid() ? date : null;
};

export const formatNotificationDate = (value) => (
  parseNotificationDate(value)?.format("DD/MM/YYYY") || ""
);

export const formatNotificationAge = (value, now = Date.now()) => (
  parseNotificationDate(value)?.from(moment(now)) || ""
);

export const notificationReceivedAt = (row = {}) => (
  [row.created_at, row.received_at].find(value => parseNotificationDate(value)) || ""
);

export const formatBookingNotificationDate = (row = {}) => (
  formatNotificationDate(row.appointment?.local_start_datetime)
  || formatNotificationDate(row.appointment_date)
  || formatNotificationDate(row.appointment?.dateof)
);
